var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmail = function SvgEmail(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 88,
    viewBox: "0 0 76 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 0L76 22V66L38 88L0 66V22L38 0Z",
    fill: "url(#paint0_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 40.3508V59.1218L29.709 48.0724C19.4372 41.2983 24.8816 44.8882 18 40.3508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2915 48.0724L57.9998 59.1218V40.3508C57.995 40.354 46.2962 48.0693 46.2915 48.0724Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6477 53.1131C38.2559 53.3723 37.7447 53.3728 37.352 53.1131L31.7269 49.4033L19.7842 60.6731H56.2156L44.2736 49.4033L38.6477 53.1131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4817 21.5227L34.209 24.4081H41.7917L38.519 21.5227C38.2226 21.2613 37.7781 21.2613 37.4817 21.5227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2217 40.3163C22.2217 37.6194 22.2217 37.7693 22.2217 34.9751C19.5076 37.3677 20.2496 36.7136 18.7559 38.0308C18.7559 38.0308 20.5009 39.1818 22.2217 40.3163Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2437 38.0308C55.7755 36.7361 56.6252 37.4852 53.7778 34.9751V40.3163C55.4961 39.1836 57.2437 38.0308 57.2437 38.0308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.9998 50.722C41.8543 48.1804 46.9291 44.8336 51.4249 41.8687V27.5455C51.4249 27.1124 51.0738 26.7612 50.6406 26.7612H25.359C24.9258 26.7612 24.5747 27.1124 24.5747 27.5455V41.8687C36.3029 49.6034 31.8575 46.672 37.9998 50.722ZM31.9496 32.2248H44.05C44.6994 32.2248 45.2265 32.7518 45.2265 33.4012C45.2265 34.0514 44.6994 34.5777 44.05 34.5777H31.9496C31.3002 34.5777 30.7731 34.0514 30.7731 33.4012C30.7731 32.7518 31.3002 32.2248 31.9496 32.2248ZM30.7731 39.3424V39.3346C30.7731 38.7306 31.2296 38.2318 31.8163 38.1659H44.1833C44.77 38.2318 45.2265 38.7306 45.2265 39.3346V39.3424C45.2226 39.9887 44.6971 40.511 44.05 40.511H31.9496C31.3026 40.511 30.7771 39.9887 30.7731 39.3424Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 0,
    x2: 71.1411,
    y2: -3.76683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73C94B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15B568"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(18 21)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmail);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/email.0ec1c3a4be1a908722e76db730097c9b.svg";